export const getItemColor = (el, defaultTypeValues) => {
  const {
    type
  } = el;
  let color = '';
  if (type && defaultTypeValues) {
    defaultTypeValues.forEach(el => {
      if (el.value === type[0]) {
        color = el.color;
      }
    });
  }
  return color;
};